module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login__logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo_s.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "cursor": "pointer",
      "margin-left": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.gName)
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login__form"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "login__body",
    staticStyle: {
      "transform": "translate(-0.5px, 0)"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "textbox__login",
    staticStyle: {
      "transform": "translate(7px, 0)",
      "font-size": "14px"
    },
    attrs: {
      "type": "search",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }],
    staticClass: "textbox__login",
    staticStyle: {
      "transform": "translate(-1px, 0)",
      "font-size": "14px"
    },
    attrs: {
      "type": "textbox",
      "maxlength": "6",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    style: (_vm.styleObject),
    attrs: {
      "id": "hi",
      "disabled": _vm.hasGetCode
    },
    on: {
      "click": _vm.getVerificationCode
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "textbox__login",
    staticStyle: {
      "top": "0px",
      "font-family": "'Microsoft Yahei'",
      "transform": "translate(-1px, 0)",
      "font-size": "14px"
    },
    attrs: {
      "type": "textbox",
      "placeholder": "6-16位字母数字混合新密码"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "textbox__login",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [(_vm.showError) ? _c('li', {
    staticClass: "textbox__login error",
    staticStyle: {
      "font-size": "14px",
      "transform": "translate(0, 1px)",
      "border-bottom": "none"
    }
  }, [_vm._v(_vm._s(_vm.error) + _vm._s(_vm.errorMsg))]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button__login",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPass
    }
  }, [_vm._v("重置密码")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login__title"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../static/images/logo-font.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto 15px"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "22px",
      "color": "#999"
    }
  }, [_vm._v("忘记密码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7965fbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/reset.vue
// module id = 1023
// module chunks = 2